import './index.css'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router';
import { JwtInterceptor } from './services/jwt-interceptor.js';
import { connectionMonitor } from './services/connection-monitor.js';
import muiTheme from "./config/mui-theme.js";
import * as Sentry from "@sentry/react";
import setupConsoleErrorCapture from "./sentry-console.js";

// Registrazione manuale per evitare il reload automatico di virtual:pwa-register su controllerchange.
// Il SW usa skipWaiting() nell'install, quindi non entra mai in stato waiting:
// onNeedRefresh di virtual:pwa-register non scatterebbe mai, ma il listener su controllerchange
// causerebbe comunque un reload silenzioso bypassando il dialog di UpdateNotifier.
if ('serviceWorker' in navigator) {
    const swUrl = import.meta.env.DEV ? '/dev-sw.js?dev-sw' : '/service-worker.js';
    const swType = import.meta.env.DEV ? 'module' : 'classic';
    navigator.serviceWorker.register(swUrl, { type: swType }).then(reg => {
        setInterval(() => reg.update(), 60 * 1000);
    });
}

// Cleanup chiave legacy v1 di useSelectedStockLocations. Il nuovo hook usa
// `stock_locations_items_v2`; la rimozione è idempotente (no-op se già assente).
localStorage.removeItem('stock_locations_items');

JwtInterceptor();
connectionMonitor.start();

Sentry.init({
    dsn: "https://694d7a291c3a773b24a994dead42f75d@o4509238365847552.ingest.de.sentry.io/4509238373711952",
    sendDefaultPii: true,
    environment: import.meta.env.MODE || "production",
    // integrations: [
    //     Sentry.browserTracingIntegration()
    // ],
    // tracesSampleRate: 0.3, //  1 = capture 100% of the transactions
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/]
});

setupConsoleErrorCapture();

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <BrowserRouter>
            <ThemeProvider theme={muiTheme}>
                <CssBaseline />
                <App />
            </ThemeProvider>
        </BrowserRouter>
    </StrictMode>,
)